import {
  getConfiguration,
  updateConfiguration,
} from '../../../services/configurationManager';
import { parseHeartRateData } from '../../../utils/hrDataRepair';
import { repairHeartRateEventsWithAi } from './repairHeartRateEventsWithAi';
import type { AiRepairSessionResult } from './types';

export const repairSessionHrDataWithAi = async (
  sessionId: number
): Promise<AiRepairSessionResult> => {
  const configuration = await getConfiguration(sessionId);
  const originalEvents = parseHeartRateData(configuration.data.hrData);
  const result = await repairHeartRateEventsWithAi(originalEvents);

  if (result.status !== 'success' || !result.repairedEvents) {
    return result;
  }

  await updateConfiguration(sessionId, {
    hrData_repaired: result.repairedEvents,
  });

  return result;
};
